import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AdministratorRoute from "../Administrator";
import TeacherRoute from "../Teacher";
import VisitorHome from "./routes/VisitorHome";
import SchoolOnboardSetup from "SchoolOnboardSetup";
import SymLinks from "./routes/SymLinks";
import PublicLinks from "./routes/PublicLinks";
import Profile from "./routes/Profile";
import ProfileV2 from "./routes/ProfileV2";
import TeacherProfile from "./routes/TeacherProfile";
import OrganizationSwitcher from "./routes/OrganizationSwitcher";
import RegionsRoute from "./routes/Regions";
import PlatformAccessManager from "./routes/PlatformAccessManager";
import Tools from "./routes/Tools";
import FamilyProfile from "./routes/FamilyProfile";
import MessagingV2 from "./routes/MessagingV2";
import AdminSettings from "./routes/AdminSettings";
import CoreSettings from "./routes/CoreSettings";
import TeacherTimeTable from "../Teacher/routes/TeacherTimeTable";
import HomePage from "./routes/HomePage";
import SchoolPortal from "./routes/SchoolPortal";
import AcademicPortal from "./routes/AcademicPortal";
import AcademicAccountPortal from "./routes/AcademicAccountPortal";
import WorkflowPage from "./routes/WorkflowSubtaskFeed";
import Bin from "./routes/Bin";

import { getRelativePath } from "Utils";

export default store => ({
  path: "platform",
  component: withAsyncRouteLoading(
    () =>
      new Promise((cb, reject) => {
        require.ensure(
          [],
          require => {
            const component = require("./components").default;
            const reducer = require("Platform/modules/PlatformModule").default;
            injectReducer(store, { key: "platform", reducer });
            cb(component);
          },
          err => {
            reject(err);
          },
          "teacher-course"
        );
      })
  ),
  onEnter: (nextState, replace) => {
    const pathname = _.get(nextState, "location.pathname", "");
    const currentRoute = _.last(pathname.split("/"));

    if (_.includes(["tools"], currentRoute)) {
      replace(getRelativePath("../regions"));
    }
  },
  childRoutes: [
    SymLinks(store),
    PublicLinks(store),
    OrganizationSwitcher(store),
    VisitorHome(store),
    AdministratorRoute(store),
    AdminSettings(store),
    CoreSettings(store),
    SchoolOnboardSetup(store),
    RegionsRoute(store),
    PlatformAccessManager(store),
    Bin(store),
    Tools(store),
    Profile(store),
    ProfileV2(store),
    FamilyProfile(store),
    TeacherProfile(store),
    ..._.map(MessagingV2, comp => comp(store)),
    HomePage(store),
    AcademicAccountPortal(store),
    AcademicPortal(store),
    SchoolPortal(store),
    TeacherRoute(store),
    TeacherTimeTable(store),
    WorkflowPage(store),
  ],
});
